import {Injectable, InjectionToken} from '@angular/core';
import {get} from 'lodash';
import {CommonAppGeneralConfig, CommonGeneralConfigService} from 'common-framework';

export interface AppGeneralConfig extends CommonAppGeneralConfig{
  mobile_number?: {
    country_code: string;
    regex: string;
  };
  listingComponentConfig?: {
    ellipsisEffect: boolean;
  };
  headerConfig?: {
    displayUserFullname: boolean;
  };
  addUserConfig?: {
    phoneOptional: boolean;
  };
  addRoleConfig?: {
    myAccountCheckDisabled: boolean;
  };
  commonConfig?: CommonAppGeneralConfig['commonConfig'] & {
    hasMobileApp?: boolean;
    showCopyright?: boolean;
    showDesignedDevelopedByFoo?: boolean;
    showLoaderBlurBackground?: boolean;
    cardCountUpAnimation?: boolean | {duration: number};
  };
  applicationDetailsConfig?: {
    showAdditionalInformationPanel: boolean;
  };
  usersConfig?: {
    canUpdateAllUsers: boolean;
    hideSearchForRoles: boolean;
  };
  loginConfig?: {
    browserCredentialsSave: boolean;
  };
  customerCardListConfig?: {
    hideIssueVirtualCard: boolean;
  };
  cardTransactionsConfig?: {
    hideAdvancedSearch: boolean;
  };
  customerConfig?: {
    requestDevicesLogs: boolean;
  };
  merchantsConfig?: {
      maxReferenceLength?: number
  };
  [key: string]: any;
}

@Injectable()
export class GeneralConfigService extends CommonGeneralConfigService{
  config: AppGeneralConfig  =  {};
  setConfig(config: AppGeneralConfig): void {
    this.config = {...this.config, ...(config || {})};
  }
}
